export default __webpack_public_path__ + "static/media/blog3.e5540fb9.png";